
if($('.whyUsWrapper').length){
document.addEventListener("DOMContentLoaded", function () {
  const track = document.querySelector(".sliderTrack");
  const slides = Array.from(track.querySelectorAll(".inner"));
  const listItems = document.querySelectorAll(".left li");
  const prevBtn = document.querySelector(".arrows .prev");
  const nextBtn = document.querySelector(".arrows .next");

  let currentIndex = 0;

  function goToSlide(index) {
    if (index < 0) index = slides.length - 1;
    if (index >= slides.length) index = 0;
    track.style.transform = `translateX(-${index * 100}%)`;
    currentIndex = index;

    // Aktivní stav v levém menu
    listItems.forEach(li => li.classList.remove("active"));
    listItems[index]?.classList.add("active");
  }

  // Kliknutí na položku v levém menu
  listItems.forEach((li, index) => {
    li.addEventListener("click", () => {
      goToSlide(index);
    });
  });

  // Šipky
  prevBtn.addEventListener("click", () => goToSlide(currentIndex - 1));
  nextBtn.addEventListener("click", () => goToSlide(currentIndex + 1));

  // Načtení první položky
  goToSlide(0);
});
}

